import { useEffect, useRef } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';

type RequireRolesProps = {
  anyOf: string[];
};

export function RequireRoles({ anyOf }: RequireRolesProps) {
  const { user } = useAuth();
  const { showToast } = useToast();
  const deniedRef = useRef(false);

  const allowed = Boolean(user?.roles.some((r) => anyOf.includes(r)));

  useEffect(() => {
    if (user && !allowed && !deniedRef.current) {
      deniedRef.current = true;
      showToast('Accès refusé.', { tone: 'error' });
    }
  }, [allowed, showToast, user]);

  if (!user) return null;
  if (!allowed) return <Navigate to="/" replace />;
  return <Outlet />;
}
